import React, { Fragment } from 'react';
import Zonelist from './Zonelist'

const Zone = () => {
    return (
        <Fragment>
            <Zonelist />
        </Fragment>
    );
};

export default Zone;
